import { render, staticRenderFns } from "./SurveyGiftManage.vue?vue&type=template&id=52b0530d&"
import script from "./SurveyGiftManage.vue?vue&type=script&lang=js&"
export * from "./SurveyGiftManage.vue?vue&type=script&lang=js&"
import style0 from "./SurveyGiftManage.vue?vue&type=style&index=0&id=52b0530d&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b0530d')) {
      api.createRecord('52b0530d', component.options)
    } else {
      api.reload('52b0530d', component.options)
    }
    module.hot.accept("./SurveyGiftManage.vue?vue&type=template&id=52b0530d&", function () {
      api.rerender('52b0530d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/survey-gift-manage/SurveyGiftManage.vue"
export default component.exports